"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _menu = require("@alicd/next/lib/menu");

var _menu2 = _interopRequireDefault(_menu);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get4 = require("babel-runtime/helpers/get");

var _get5 = _interopRequireDefault(_get4);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SelectAllMonkey2 = require("./SelectAllMonkey");

var _SelectAllMonkey3 = _interopRequireDefault(_SelectAllMonkey2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectReadOnly = function (_SelectAllMonkey) {
    (0, _inherits3.default)(SelectReadOnly, _SelectAllMonkey);

    function SelectReadOnly() {
        (0, _classCallCheck3.default)(this, SelectReadOnly);
        return (0, _possibleConstructorReturn3.default)(this, (SelectReadOnly.__proto__ || (0, _getPrototypeOf2.default)(SelectReadOnly)).apply(this, arguments));
    }

    (0, _createClass3.default)(SelectReadOnly, [{
        key: "onSelect",
        value: function onSelect() {
            var _get2;

            if (this.props.readOnly) {
                return;
            }

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return (_get2 = (0, _get5.default)(SelectReadOnly.prototype.__proto__ || (0, _getPrototypeOf2.default)(SelectReadOnly.prototype), "onSelect", this)).call.apply(_get2, [this].concat(args));
        }
    }, {
        key: "renderMenuItem",
        value: function renderMenuItem() {
            var _get3;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            var ret = (_get3 = (0, _get5.default)(SelectReadOnly.prototype.__proto__ || (0, _getPrototypeOf2.default)(SelectReadOnly.prototype), "renderMenuItem", this)).call.apply(_get3, [this].concat(args));
            if (this.props.readOnly && (ret.type == _menu2.default.Item || ret.type == _menu2.default.CheckboxItem)) {
                return _react2.default.cloneElement(ret, { disabled: true });
            }
            return ret;
        }
    }]);
    return SelectReadOnly;
}(_SelectAllMonkey3.default);

SelectReadOnly.propTypes = (0, _assign2.default)({
    readOnly: _propTypes2.default.bool
}, _SelectAllMonkey3.default.propTypes);
SelectReadOnly.defaultProps = (0, _assign2.default)({}, _SelectAllMonkey3.default.defaultProps);
exports.default = SelectReadOnly;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-select-field@0.0.22@@alicd/crui-select-field/lib/SelectReadOnly.js
// module id = 664
// module chunks = 0